import React from 'react';
import PropTypes from 'prop-types';
import { Toolbar, ToolbarGroup, ToolbarTitle } from 'material-ui/Toolbar';
import RaisedButton from 'material-ui/RaisedButton';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import COLORS from '../../theme/colors';
import './invite_manager.scss';

export default class InviteManager extends React.Component {
  static propTypes = {
    invites: PropTypes.array,
    loadInvites: PropTypes.func.isRequired,
    generateInvite: PropTypes.func.isRequired,
    revokeInvite: PropTypes.func.isRequired,
  };

  static defaultProps = {
    invites: [],
  };

  componentWillMount() {
    this.props.loadInvites();
  }

  renderInvites() {
    const urlPrefix = `${window.location.host}/guest?inviteId=`;

    return this.props.invites.map((invite) => {
      return (
        <Toolbar
          key={invite.id}
          className="invite"
          style={{
            backgroundColor: COLORS.white,
            borderBottom: `1px solid ${COLORS.blue}`,
          }}
        >
          <ToolbarGroup
            className="invite-url"
            firstChild
          >
            { `${urlPrefix}${invite.accessToken}` }
          </ToolbarGroup>
          <ToolbarGroup lastChild>
            <ClearIcon
              color={COLORS.gray}
              hoverColor={COLORS.black}
              className="revoke-invite"
              onClick={() => { this.props.revokeInvite(invite.id); }}
            />
          </ToolbarGroup>
        </Toolbar>
      );
    });
  }

  render() {
    return (
      <div className="invite-manager">
        <Toolbar style={{ backgroundColor: COLORS.blue }}>
          <ToolbarGroup firstChild>
            <ToolbarTitle text="Invites" style={{ paddingLeft: '20px', color: COLORS.white }} />
          </ToolbarGroup>
          <ToolbarGroup lastChild>
            <RaisedButton
              label="Generate"
              primary
              onClick={() => { this.props.generateInvite(); }}
            />
          </ToolbarGroup>
        </Toolbar>
        <div className="invites-description">
          <p>Allow your teammates to display your TeamHub content on their TV.
            Generate an invitation link and share it with them.
          </p>
        </div>
        <div className="invites">
          {
            !this.props.invites.length
              ? 'No invites generated.'
              : this.renderInvites()
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/invite_manager/invite_manager.jsx